import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Details } from './components';
import useConditionQueries from './useConditionQueries';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: theme.spacing(3)
  }
}));

const ConditionQueryDetails = props => {
  const template = useConditionQueries();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Details
          template={template}
          showNav={true}
          next="/condition-queries/design"
        />
      </div>
    </div>
  );
};

export default ConditionQueryDetails;